import { YubinBangoCore } from 'yubinbango-core-strict/yubinbango-core.js';
import { getConfigByLanguage } from './config/config.js';
import validationClasses from './config/validationClasses.js';
import FormValidator from './lib/formValidator.js';
import * as util from './lib/utility.js';
/**
 * フォームのバリデーションと送信ボタンの制御を行うクラス
 * @class TopValidation
 * @extends FormValidator
 */
export default class TopValidation extends FormValidator {
    /**
     * コンストラクタ
     * @param {object} config - 設定オブジェクト
     * @param {object} config.zipList - 郵便番号と住所のリスト
     * @param {string} config.zipList.zip - 郵便番号
     * @param {string} config.zipList.address01 - 住所の第一部分
     * @param {string} config.zipList.address02 - 住所の第二部分
     * @param {string} [config.language='ja'] - 使用する言語。デフォルトは日本語。
     */
    constructor(config) {
        var _a, _b, _c;
        const { validationConfig, noInputConfig } = getConfigByLanguage((_a = config.language) !== null && _a !== void 0 ? _a : 'ja');
        super(validationConfig, noInputConfig);
        this.zipList = config.zipList;
        this.form = document.querySelector('form');
        this.btnSubmit = document.querySelector(`.${validationClasses.btnSubmit}`);
        this.cloneSubmit = (_b = this.btnSubmit) === null || _b === void 0 ? void 0 : _b.cloneNode(true);
        this.allFields = document.querySelectorAll(`.${this.validationConfig.required.check}, .${this.validationConfig.anyRequired.check}, .${this.validationConfig.tel.check}, .${this.validationConfig.mail.check}, .${this.validationConfig.num.check}, .${this.validationConfig.alphabet.check}, .${this.validationConfig.alphaNum.check}, .${this.validationConfig.zip.check}, .${this.validationConfig.kana.check}, .${this.validationConfig.hiragana.check}, .${this.validationConfig.katakana.check}`);
        const excludedClasses = (_c = this.validationConfig.formArea.excludedClasses) !== null && _c !== void 0 ? _c : {};
        const flatExcludedClasses = Object.values(excludedClasses).flat();
        if (!this.form) {
            console.error({ error: `フォームタグが存在しません。`, form: this.form });
            return;
        }
        else if (util.isExcludedClasses(flatExcludedClasses)) {
            return;
        }
        if (!this.btnSubmit) {
            console.error({ error: `.${validationClasses.btnSubmit}が存在しません。`, btnSubmit: this.btnSubmit });
            return;
        }
        this.init();
    }
    /**
     * 初期化
     * @method init
     * @returns {void}
     */
    init() {
        var _a;
        this.form.classList.add((_a = this.validationConfig.formArea.check) !== null && _a !== void 0 ? _a : '');
        this.form.addEventListener('keydown', (event) => {
            if (event.key === 'Enter' && event.target !== this.btnSubmit) {
                const target = event.target;
                if (target && target.tagName !== 'TEXTAREA') {
                    event.preventDefault();
                }
            }
        });
        this.toggleSubmitButton();
        this.autoFillAddress();
        this.addValidateEvents();
    }
    /**
     * 住所を自動入力するメソッド
     * @method autoFillAddress
     * @param {string} [zip=this.zipList.zip] - 郵便番号の入力フィールドの名前
     * @param {string} [address01=this.zipList.address01] - 都道府県の入力フィールドの名前
     * @param {string} [address02=this.zipList.address02] - 住所の入力フィールドの名前
     * @returns {void}
     */
    autoFillAddress(zip = this.zipList.zip, address01 = this.zipList.address01, address02 = this.zipList.address02) {
        const zipInput = document.querySelector('[name="' + zip + '"]');
        const address01Input = document.querySelector('[name="' + address01 + '"]');
        const address02Input = document.querySelector('[name="' + address02 + '"]');
        if (!zipInput)
            return;
        zipInput === null || zipInput === void 0 ? void 0 : zipInput.addEventListener('keyup', () => {
            let zipValue = util.toHalfWidth(zipInput.value);
            zipValue = zipValue.replace(/-/g, '');
            zipInput.classList.remove(validationClasses.addrErr);
            if (zipValue && zipValue.length === 7) {
                new YubinBangoCore(zipValue, (addr) => {
                    if (addr.region_id === 0) {
                        zipInput.classList.add(validationClasses.addrErr);
                        return;
                    }
                    zipInput.value = util.toHalfWidth(zipValue);
                    if (address01Input) {
                        this.fillAddressFields(addr, address01Input, address02Input);
                    }
                });
            }
        });
    }
    /**
     * 住所フィールドに値を設定する
     * @param {Object} addr - 住所情報
     * @param {TMLSelectElement | HTMLInputElement} address01Input - 都道府県フィールド
     * @param {HTMLInputElement | null} address02Input - 住所フィールド
     */
    fillAddressFields(addr, address01Input, address02Input) {
        if (address01Input.tagName === 'SELECT') {
            const selectElement = address01Input;
            const options = selectElement.options;
            for (let i = 0; i < options.length; i++) {
                if (options[i].text === addr.region) {
                    selectElement.selectedIndex = i;
                    break;
                }
            }
        }
        else if (address01Input.tagName === 'INPUT') {
            const inputElement = address01Input;
            inputElement.value = addr.region;
            inputElement.focus();
        }
        if (address02Input) {
            address02Input.value = addr.locality + addr.street;
            address02Input.focus();
        }
    }
    /**
     * イベントリスナーを追加するメソッド
     * @method addValidateEvents
     */
    addValidateEvents() {
        var _a;
        (_a = this.allFields) === null || _a === void 0 ? void 0 : _a.forEach(field => {
            if (field.tagName === 'SELECT' || field.tagName === 'INPUT' || field.tagName === 'TEXTAREA' && !field.classList.contains(validationClasses.anyRequired)) {
                if (field.classList.contains(validationClasses.realTime)) {
                    this.inputFieldHandler(field);
                }
                this.blurFieldHandler(field);
            }
            else {
                this.changeFieldHandler(field);
            }
        });
    }
    /**
     * 入力フィールドのblurイベントを処理するメソッド
     * @method blurFieldHandler
     * @param {HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement} triggerField - 入力フィールド
     * @returns {void}
     */
    blurFieldHandler(triggerField) {
        triggerField.addEventListener('blur', () => {
            const validationFlag = this.allCheckValidator(triggerField);
            this.displayErrorMessage(triggerField, validationFlag.err);
            this.toggleSubmitButton();
        });
    }
    /**
     * 入力フィールドのinputイベントを処理するメソッド
     * @method inputFieldHandler
     * @param {HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement} triggerField - 入力フィールド
     * @returns {void}
     */
    inputFieldHandler(triggerField) {
        triggerField.addEventListener('input', () => {
            const validationFlag = this.requiredValidator(triggerField);
            this.displayErrorMessage(triggerField, validationFlag.err);
            this.toggleSubmitButton();
        });
    }
    /**
     * 入力フィールドのchangeイベントを処理するメソッド <.check_any_required | radio | checkbox>
     * @method changeFieldHandler
     * @param {HTMLElement} triggerField - 変更されたフィールド（チェックボックスやラジオボタン）
     * @returns {void}
     */
    changeFieldHandler(triggerField) {
        triggerField === null || triggerField === void 0 ? void 0 : triggerField.addEventListener('change', () => {
            const isAnyRequired = triggerField.classList.contains(validationClasses.anyRequired);
            const validationFlag = isAnyRequired
                ? this.anyRequiredValidator(triggerField)
                : this.allCheckValidator(triggerField);
            this.displayErrorMessage(triggerField, validationFlag.err);
            this.toggleSubmitButton();
        });
    }
    /**
     * エラーメッセージの表示・非表示を行うメソッド
     * @method displayErrorMessage
     * @param {HTMLInputElement} field - 入力フィールド
     * @param {string} err - エラーの種類を示す文字列
     * @returns {void}
     */
    displayErrorMessage(field, err) {
        var _a;
        let errText = field.nextElementSibling;
        if (err === '') {
            field.classList.remove(validationClasses.err);
            field.classList.add(validationClasses.through);
            if (errText && errText.classList.contains(validationClasses.err)) {
                errText.remove();
            }
        }
        else {
            field.classList.add(validationClasses.err);
            field.classList.remove(validationClasses.through);
            if (!errText || !errText.classList.contains(validationClasses.err)) {
                errText = document.createElement('p');
                errText.classList.add(validationClasses.err);
                field.insertAdjacentElement('afterend', errText);
            }
            errText.textContent = (_a = this.validationConfig[err].errText) !== null && _a !== void 0 ? _a : '';
        }
    }
    /**
     * 送信ボタンの表示・非表示を行うメソッド
     * @method toggleSubmitButton
     * @returns {void}
     */
    toggleSubmitButton() {
        var _a, _b;
        if (this.isValidForm()) {
            const classNames = this.noInputConfig.classes.split(' ');
            const errorBox = document.querySelector(`.${classNames[0]}`);
            if (errorBox) {
                errorBox.insertAdjacentElement('afterend', this.cloneSubmit);
                errorBox.remove();
            }
        }
        else {
            this.btnSubmit = document.querySelector(`.${validationClasses.btnSubmit}`);
            if (this.btnSubmit) {
                const errorBox = `<p class="${this.noInputConfig.classes}"><span>${this.noInputConfig.errText}</span></p>`;
                (_a = this.btnSubmit) === null || _a === void 0 ? void 0 : _a.insertAdjacentHTML('afterend', errorBox);
                (_b = this.btnSubmit) === null || _b === void 0 ? void 0 : _b.remove();
            }
        }
    }
    /**
     * フォーム全体のバリデーションチェックを行うメソッド
     * @method isValidForm
     * @returns {boolean} - バリデーションエラーがない場合は true、エラーがある場合は false を返す。
     */
    isValidForm() {
        const flags = [];
        const requiredFields = Array.from(this.allFields).filter(field => {
            var _a, _b;
            return field.classList.contains((_a = this.validationConfig.required.check) !== null && _a !== void 0 ? _a : '') || field.classList.contains((_b = validationClasses.anyRequired) !== null && _b !== void 0 ? _b : '');
        });
        for (const field of requiredFields) {
            const validationFlag = field.classList.contains(validationClasses.anyRequired) ?
                this.anyRequiredValidator(field) :
                this.allCheckValidator(field);
            flags.push(validationFlag);
        }
        for (const field of this.allFields) {
            const validationFlag = this.allCheckValidator(field);
            flags.push(validationFlag);
        }
        return flags.some(result => result.through === 0) ? false : true;
    }
}
//# sourceMappingURL=topValidation.js.map